const steps = [
  {
    num: "1",
    title: "Choose Your Service",
    desc: "Select emergency, expedited, or standard processing. We recommend the 2–9 day option for most Grand Forks travelers.",
  },
  {
    num: "2",
    title: "Complete Your Application",
    desc: "Fill out our guided online form. We auto-check for errors and flag missing documents before submission.",
  },
  {
    num: "3",
    title: "Visit a Local Acceptance Facility",
    desc: "Bring your documents to a Grand Forks post office or clerk. We’ll tell you exactly which one and what to bring.",
  },
  {
    num: "4",
    title: "We Submit via Registered Courier",
    desc: "Your sealed application is hand-delivered to a U.S. passport agency by a registered courier — no mail delays.",
  },
  {
    num: "5",
    title: "Receive Your Passport Fast",
    desc: "2–9 days later, your passport arrives at your Grand Forks address. Daily tracking updates keep you informed.",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            Get Your Passport in 5 Simple Steps
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-base leading-relaxed">
            From Grand Forks to your destination — our process is designed to be fast, transparent, and stress-free.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="relative text-center">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#F6C344] text-[#1A365D] font-bold text-xl mx-auto mb-4">
                {step.num}
              </div>
              <h3 className="font-bold text-white text-base mb-2">{step.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{step.desc}</p>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-7 left-[calc(50%+2rem)] w-[calc(100%-4rem)] h-px bg-white/20"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}